module.exports = __webpack_public_path__ + "img/1964-M.C.849f2b4e.png";